// extracted by mini-css-extract-plugin
module.exports = {"emptyImagePage":"Emptylist_emptyImagePage__1703z"};